/* FD brand ---------------------------------------------------------------
   Furniture Done contact page: form polish. Two jobs, both optional.

   1. ?topic= preselects the subject, so a link arriving from a product page
      (e.g. a fabric-sample enquiry) lands on the right one. Liquid cannot
      read a query string, so this half has to be JS. An unknown slug is
      ignored rather than erroring: the dropdown keeps its first topic.

   2. It takes over validation for the three required fields so the messages
      read in our own words, appear under the field they belong to, and move
      focus to the first one that needs fixing.

   Everything here is enhancement. With JS off the form still posts to
   Shopify, and the browser runs its own required-field checks against the
   `required` attributes in the markup — which is why novalidate is set HERE
   and not written into the HTML. Turning JS off must never turn validation
   off with it.

   A field is only re-checked as somebody types once it has already failed.
   Nobody wants to be told their half-typed email is wrong.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  function init(root) {
    var form = root.querySelector('form');
    if (!form) return;

    var topic = root.querySelector('[data-fd-topic]');
    if (topic) {
      var want = new URLSearchParams(window.location.search).get('topic');
      if (want) {
        var known = Array.prototype.some.call(topic.options, function (option) {
          return option.value === want;
        });
        if (known) topic.value = want;
      }
    }

    var specs = [
      { id: 'FdContact-name', message: root.getAttribute('data-fd-msg-name') },
      { id: 'FdContact-email', message: root.getAttribute('data-fd-msg-email') },
      { id: 'FdContact-body', message: root.getAttribute('data-fd-msg-body') }
    ];

    var fields = [];

    specs.forEach(function (spec) {
      var input = root.querySelector('#' + spec.id);
      var error = root.querySelector('#' + spec.id + '-error');
      if (!input || !error) return;
      fields.push({ input: input, error: error, message: spec.message || '' });
    });

    if (!fields.length) return;

    /* The markup carries `required`; from here the script owns the checks. */
    form.noValidate = true;

    function check(field) {
      var value = field.input.value.trim();
      var good = value !== '' && field.input.checkValidity();

      field.input.setAttribute('aria-invalid', String(!good));
      field.error.textContent = good ? '' : field.message;
      field.error.hidden = good;
      return good;
    }

    fields.forEach(function (field) {
      field.input.addEventListener('input', function () {
        if (field.input.getAttribute('aria-invalid') === 'true') check(field);
      });
    });

    form.addEventListener('submit', function (event) {
      var bad = fields.filter(function (field) {
        return !check(field);
      });
      if (!bad.length) return;

      event.preventDefault();
      bad[0].input.focus();
    });
  }

  function boot() {
    document.querySelectorAll('[data-fd-contact]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders a section in place, so the new markup needs
     wiring again. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fd-contact]');
    if (root) init(root);
  });
})();
